import { createEffect } from '@databases/selections';

import { manuallyFireExposureEvent } from '@canvas/client-feature-flags/experiments';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createEnrollmentExposureEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.EXPERIMENT_EXPOSURE_EFFECT,
    type: 'effect',
    factory: createEffect(() => {
      let exposed = false;

      return {
        dispose() {
          exposed = false;
        },

        deltaTypes: ['selectionModified', 'selectionReplaced'],

        onDelta() {
          if (!exposed) {
            manuallyFireExposureEvent('databasesSelectionsPerformance');

            exposed = true;
          }
        },
      };
    }),
  };
}
